<div class="split-button-container"
     [class.w-full]="width === 'fill'"
     *ngIf="visible && defaultAction"
>
  <button
    [type]="type"
    [class]="mainClassNames()"
    (click)="onMainClick()"
    [disabled]="disabled || defaultAction.disabled"
    [attr.aria-disabled]="disabled || defaultAction.disabled"
    [attr.aria-busy]="isBusy"
    [class.w-full]="width === 'fill'"
    [class.align-right]="textAlign === 'right'"
    [class.align-left]="textAlign === 'left'"
    [class.is-busy]="isBusy"
    [title]="title"
  >
    <i
      class="fa-icon {{defaultAction.faIcon}}"
      [class.order-2]="iconPosition === 'right'"
      *ngIf="defaultAction.faIcon"
      aria-hidden="true"
    ></i>
    <span class="text">{{ defaultAction.label }}</span>

    <span class="spinner" *ngIf="isBusy">
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    </span>
  </button>

  <button
    *ngIf="dropdownActions.length"
    type="button"
    [class]="toggleClassNames()"
    (click)="onToggleDropdown($event)"
    [disabled]="disabled"
    [attr.aria-expanded]="dropdownOpen"
    aria-haspopup="true"
    aria-label="More actions"
  >
    <i class="fas fa-angle-down" aria-hidden="true"></i>
  </button>

  <ul class="split-dropdown size-{{size}}" *ngIf="dropdownOpen && dropdownActions.length" role="menu">
    <li *ngFor="let action of dropdownActions"
        role="menuitem"
        class="action-{{action.dropdownVariant || 'secondary'}}"
        [class.disabled]="action.disabled"
        (click)="onActionClick(action, $event)">
      <i *ngIf="action.dropdownFaIcon || action.faIcon" class="{{action.dropdownFaIcon || action.faIcon}}" aria-hidden="true"></i>
      {{ action.dropdownLabel || action.label }}
    </li>
  </ul>
</div>
